<template>
  <div
    class="c-divide"
    :class="{
      'c-divide--no-dashed': dashed || whiteDashed,

    }"
    :style="{
      marginTop: `${mt}px`,
      marginBottom: `${mb}px`,
    }"
  >
    <svg width="100%" height="1" version="1.1" xmlns="http://www.w3.org/2000/svg" v-if="dashed">
      <line x1="0" y1="0" x2="100%" y2="0" stroke="#805a35" stroke-width="3" stroke-dasharray="5, 5"></line>
    </svg>

    <svg width="100%" height="1" version="1.1" xmlns="http://www.w3.org/2000/svg" v-if="whiteDashed">
      <line x1="0" y1="0" x2="100%" y2="0" stroke="#fff" stroke-width="3" stroke-dasharray="5, 5"></line>
    </svg>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Divide',
  props: {
    mt: {
      type: [String, Number],
      default: '20',
    },
    mb: {
      type: [String, Number],
      default: '20',
    },
    dashed: {
      type: Boolean,
      default: false,
    },
    whiteDashed: {
      type: Boolean,
      default: false,
    },
    opacity: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
<style lang="scss" scoped>
.c-divide {
  border-bottom: 1px solid rgba($c-main, 0.2);
  width: 100%;

  &--no-dashed {
    border: 0px;
  }

  &__dashed {
    height: 1px;
  }
}
</style>
